function convertToDDMMYYYY(dateStr) {
    const [year, month, day] = dateStr?.split("-");
    return `${day}/${month}/${year}`;
  }

  function convertToYYYYMMDD(dateStr) {
    const [day, month, year] = dateStr?.split("/");
    return `${year}-${month}-${day}`;
  }


function getNextDate(dateStr) {
    // Split the input date string into an array [year, month, day]
    const [year, month, day] = dateStr.split('-').map(Number);

    // Create a new Date object using the provided date
    const date = new Date(year, month - 1, day); // month is 0-indexed in JavaScript

    // Increment the date by 1 day
    date.setDate(date.getDate() + 1);

    // Format the new date to yyyy-mm-dd
    const nextYear = date.getFullYear();
    const nextMonth = String(date.getMonth() + 1).padStart(2, '0'); // month is 0-indexed, so add 1
    const nextDay = String(date.getDate()).padStart(2, '0');

    return `${nextYear}-${nextMonth}-${nextDay}`;
}
function getMonth(){
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const day = String(firstDayOfMonth.getDate()).padStart(2, "0");
  const month = String(firstDayOfMonth.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = firstDayOfMonth.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}
function setupInitialDate(object) {    
    Object.keys(object)?.map((key) => {
        if((key?.toLowerCase()?.includes("date") || key==="Month") && object[key]?.length > 0) {
            // let tempDate = object[key]?.split("T")?.[0];
            // let nextDate = getNextDate(tempDate);
            // object[key] = nextDate;
            let tempDate = object[key]?.split("/");
            let [dd, mm, yyyy] = tempDate;
            let newDate = [yyyy,mm,dd]?.join("-")
            // let nextDate = getNextDate(tempDate);
            object[key] = newDate;
        }
    })
    return object;
}
function getTodaysDate(){
  let today = new Date();
  today = today?.toISOString()?.split("T")?.[0];
  return today;
};

function convertArrayToCSV(data){
  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','), // Header row
    ...data.map(row => headers.map(header => `"${row[header] || ''}"`).join(',')) // Data rows
  ];

  return csvRows.join('\n');
};

function getAudioFileName() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const consultant = localStorage.getItem("name")?.split(" ")?.[0]

  return `${day}_${month}_${year}_${hours}_${minutes}_${seconds}_${consultant}`;
}



  export {getMonth,getTodaysDate, setupInitialDate, convertToDDMMYYYY, convertToYYYYMMDD, convertArrayToCSV, getAudioFileName};